import React, { createContext, useContext, useState, useCallback } from 'react';
import Drawer from '../components/Drawer';

const DrawerContext = createContext(null);
export const useDrawer = () => useContext(DrawerContext);

export function DrawerProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState(null);

  const open = useCallback((node, options = {}) => {
    if (node !== undefined && node !== null) setContent(node);
    setIsOpen(true);
    if (options && typeof options.onOpen === 'function') options.onOpen();
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const setDrawerContent = useCallback((node) => {
    setContent(node);
  }, []);

  const value = {
    open, // open(content, { onOpen })
    close, // close()
    setContent: setDrawerContent, // setContent(node)
    isOpen,
    content,
  };

  return (
    <DrawerContext.Provider value={value}>
      <Drawer isOpen={isOpen} onClose={close}>
        {content}
      </Drawer>
      {children}
    </DrawerContext.Provider>
  );
}

export default DrawerProvider;
